export enum StandalonePages {
  AutomaticTransfers = "/standalone/automatic-transfers",
  DownloadTheApp = "/standalone/download-the-app",
  InvoiceEmailPreview = "/standalone/invoice-email-preview",
}
